var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_5821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.334 0C25.6477 2.57702e-07 28.334 2.68629 28.334 6V22C28.334 25.3137 25.6477 28 22.334 28H18.9717V16.917H22.1035L22.501 13.1064H19.0371C18.9744 13.0687 18.9766 13.0201 18.9688 12.957C18.9122 12.4831 18.9441 10.7584 19.083 10.3369C19.181 10.039 19.3551 9.83199 19.667 9.74219C19.7926 9.7062 20.1964 9.64364 20.3164 9.64355H22.501V5.83301H18.7061L18.6367 5.87305C15.9926 5.94389 14.4929 7.5548 14.3369 10.0957C14.2816 10.9984 14.4448 12.0886 14.3408 12.957C14.333 13.0202 14.3355 13.0687 14.2725 13.1064H12.001V16.917H14.2949V28H6.33398C3.02028 28 0.333984 25.3137 0.333984 22V6C0.333985 2.68629 3.02028 3.22128e-08 6.33398 0H22.334Z",
    fill: "#1878F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.8335V9.64347H20.316C20.1963 9.64347 19.7926 9.70605 19.6668 9.74207C19.3546 9.83181 19.1801 10.0391 19.082 10.3372C18.943 10.7588 18.9118 12.484 18.9683 12.9575C18.9761 13.0207 18.9737 13.0691 19.0369 13.1069H22.5L22.1029 16.9169H18.9707V28.0002H14.2941V16.9169H12V13.1069H14.2718C14.335 13.0691 14.3326 13.0207 14.3404 12.9575C14.4445 12.089 14.2809 10.9991 14.3362 10.0963C14.492 7.55516 15.9913 5.9445 18.6356 5.87365L18.7054 5.8335H22.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_5821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookImage);
export default __webpack_public_path__ + "static/media/facebook-image.e606d4e2c77aca13ebdee5d696de8fa7.svg";
export { ForwardRef as ReactComponent };